import { Placement } from '@floating-ui/react'
import { ReactNode } from 'react'

import { TooltipAnchor } from './TooltipAnchor'
import { TooltipContent } from './TooltipContent'
import { useTooltipState } from './useTooltipState'

export interface TooltipProps {
  children: ReactNode
  content: ReactNode
  placement?: Placement
  theme?: 'light' | 'dark'
  disabled?: boolean
  className?: string
}

export function Tooltip({
  children,
  disabled,
  content,
  className,
  placement,
  theme = 'light',
}: TooltipProps) {
  const state = useTooltipState(placement)

  return (
    <>
      <TooltipAnchor state={state}>{children}</TooltipAnchor>
      {!disabled && (
        <TooltipContent theme={theme} state={state} className={className}>
          {content}
        </TooltipContent>
      )}
    </>
  )
}
